module.exports = __webpack_public_path__ + "assets/img/nav-item-3-72b2c4bc.png";